import type { ReactNode } from "react";

import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
}

const EmptyState = ({
  icon: Icon,
  title,
  description,
  children,
}: EmptyStateProps) => (
  <div className="admin-video-workspace__empty">
    <div className="workspace-empty-art" aria-hidden="true">
      <span className="workspace-empty-art__card workspace-empty-art__card--back" />
      <span className="workspace-empty-art__card workspace-empty-art__card--mid" />
      <span className="workspace-empty-art__tile">
        <Icon size={18} strokeWidth={1.75} />
      </span>
    </div>
    <p className="font-semibold text-gray-800">{title}</p>
    {description && <p className="text-sm text-gray-500">{description}</p>}
    {children}
  </div>
);

export default EmptyState;
